"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The PersonalDetails model module.
 * @module model/PersonalDetails
 * @version 3.0
 */
var PersonalDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>PersonalDetails</code>.
   * @alias module:model/PersonalDetails
   * @param title {String} 
   * @param firstName {String} 
   * @param lastName {String} 
   * @param nickName {String} 
   * @param dob {Date} 
   * @param emailAddress {String} 
   */
  function PersonalDetails(title, firstName, lastName, nickName, dob, emailAddress) {
    _classCallCheck(this, PersonalDetails);
    PersonalDetails.initialize(this, title, firstName, lastName, nickName, dob, emailAddress);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(PersonalDetails, null, [{
    key: "initialize",
    value: function initialize(obj, title, firstName, lastName, nickName, dob, emailAddress) {
      obj['title'] = title;
      obj['firstName'] = firstName;
      obj['lastName'] = lastName;
      obj['nickName'] = nickName;
      obj['dob'] = dob;
      obj['emailAddress'] = emailAddress;
    }

    /**
     * Constructs a <code>PersonalDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PersonalDetails} obj Optional instance to populate.
     * @return {module:model/PersonalDetails} The populated <code>PersonalDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new PersonalDetails();
        if (data.hasOwnProperty('title')) {
          obj['title'] = _ApiClient["default"].convertToType(data['title'], 'String');
        }
        if (data.hasOwnProperty('firstName')) {
          obj['firstName'] = _ApiClient["default"].convertToType(data['firstName'], 'String');
        }
        if (data.hasOwnProperty('middleName')) {
          obj['middleName'] = _ApiClient["default"].convertToType(data['middleName'], 'String');
        }
        if (data.hasOwnProperty('lastName')) {
          obj['lastName'] = _ApiClient["default"].convertToType(data['lastName'], 'String');
        }
        if (data.hasOwnProperty('nickName')) {
          obj['nickName'] = _ApiClient["default"].convertToType(data['nickName'], 'String');
        }
        if (data.hasOwnProperty('dob')) {
          obj['dob'] = _ApiClient["default"].convertToType(data['dob'], 'Date');
        }
        if (data.hasOwnProperty('gender')) {
          obj['gender'] = _ApiClient["default"].convertToType(data['gender'], 'String');
        }
        if (data.hasOwnProperty('primaryContactNumber')) {
          obj['primaryContactNumber'] = _ApiClient["default"].convertToType(data['primaryContactNumber'], 'String');
        }
        if (data.hasOwnProperty('primaryContactNumberCountryCode')) {
          obj['primaryContactNumberCountryCode'] = _ApiClient["default"].convertToType(data['primaryContactNumberCountryCode'], 'String');
        }
        if (data.hasOwnProperty('emailAddress')) {
          obj['emailAddress'] = _ApiClient["default"].convertToType(data['emailAddress'], 'String');
        }
        if (data.hasOwnProperty('countryOfResidence')) {
          obj['countryOfResidence'] = _ApiClient["default"].convertToType(data['countryOfResidence'], 'String');
        }
        if (data.hasOwnProperty('nationality')) {
          obj['nationality'] = _ApiClient["default"].convertToType(data['nationality'], 'String');
        }
        if (data.hasOwnProperty('pictureFormat')) {
          obj['pictureFormat'] = _ApiClient["default"].convertToType(data['pictureFormat'], 'String');
        }
        if (data.hasOwnProperty('pictureBase64')) {
          obj['pictureBase64'] = _ApiClient["default"].convertToType(data['pictureBase64'], 'String');
        }
        if (data.hasOwnProperty('taxCode')) {
          obj['taxCode'] = _ApiClient["default"].convertToType(data['taxCode'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PersonalDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PersonalDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(PersonalDetails.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data.hasOwnProperty(property)) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
        throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
      }
      // ensure the json data is a string
      if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
        throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
      }
      // ensure the json data is a string
      if (data['middleName'] && !(typeof data['middleName'] === 'string' || data['middleName'] instanceof String)) {
        throw new Error("Expected the field `middleName` to be a primitive type in the JSON string but got " + data['middleName']);
      }
      // ensure the json data is a string
      if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
        throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
      }
      // ensure the json data is a string
      if (data['nickName'] && !(typeof data['nickName'] === 'string' || data['nickName'] instanceof String)) {
        throw new Error("Expected the field `nickName` to be a primitive type in the JSON string but got " + data['nickName']);
      }
      // ensure the json data is a string
      if (data['gender'] && !(typeof data['gender'] === 'string' || data['gender'] instanceof String)) {
        throw new Error("Expected the field `gender` to be a primitive type in the JSON string but got " + data['gender']);
      }
      // ensure the json data is a string
      if (data['primaryContactNumber'] && !(typeof data['primaryContactNumber'] === 'string' || data['primaryContactNumber'] instanceof String)) {
        throw new Error("Expected the field `primaryContactNumber` to be a primitive type in the JSON string but got " + data['primaryContactNumber']);
      }
      // ensure the json data is a string
      if (data['primaryContactNumberCountryCode'] && !(typeof data['primaryContactNumberCountryCode'] === 'string' || data['primaryContactNumberCountryCode'] instanceof String)) {
        throw new Error("Expected the field `primaryContactNumberCountryCode` to be a primitive type in the JSON string but got " + data['primaryContactNumberCountryCode']);
      }
      // ensure the json data is a string
      if (data['emailAddress'] && !(typeof data['emailAddress'] === 'string' || data['emailAddress'] instanceof String)) {
        throw new Error("Expected the field `emailAddress` to be a primitive type in the JSON string but got " + data['emailAddress']);
      }
      // ensure the json data is a string
      if (data['countryOfResidence'] && !(typeof data['countryOfResidence'] === 'string' || data['countryOfResidence'] instanceof String)) {
        throw new Error("Expected the field `countryOfResidence` to be a primitive type in the JSON string but got " + data['countryOfResidence']);
      }
      // ensure the json data is a string
      if (data['nationality'] && !(typeof data['nationality'] === 'string' || data['nationality'] instanceof String)) {
        throw new Error("Expected the field `nationality` to be a primitive type in the JSON string but got " + data['nationality']);
      }
      // ensure the json data is a string
      if (data['pictureFormat'] && !(typeof data['pictureFormat'] === 'string' || data['pictureFormat'] instanceof String)) {
        throw new Error("Expected the field `pictureFormat` to be a primitive type in the JSON string but got " + data['pictureFormat']);
      }
      // ensure the json data is a string
      if (data['pictureBase64'] && !(typeof data['pictureBase64'] === 'string' || data['pictureBase64'] instanceof String)) {
        throw new Error("Expected the field `pictureBase64` to be a primitive type in the JSON string but got " + data['pictureBase64']);
      }
      // ensure the json data is a string
      if (data['taxCode'] && !(typeof data['taxCode'] === 'string' || data['taxCode'] instanceof String)) {
        throw new Error("Expected the field `taxCode` to be a primitive type in the JSON string but got " + data['taxCode']);
      }
      return true;
    }
  }]);
}();
PersonalDetails.RequiredProperties = ["title", "firstName", "lastName", "nickName", "dob", "emailAddress"];

/**
 * @member {String} title
 */
PersonalDetails.prototype['title'] = undefined;

/**
 * @member {String} firstName
 */
PersonalDetails.prototype['firstName'] = undefined;

/**
 * @member {String} middleName
 */
PersonalDetails.prototype['middleName'] = undefined;

/**
 * @member {String} lastName
 */
PersonalDetails.prototype['lastName'] = undefined;

/**
 * @member {String} nickName
 */
PersonalDetails.prototype['nickName'] = undefined;

/**
 * @member {Date} dob
 */
PersonalDetails.prototype['dob'] = undefined;

/**
 * @member {String} gender
 */
PersonalDetails.prototype['gender'] = undefined;

/**
 * @member {String} primaryContactNumber
 */
PersonalDetails.prototype['primaryContactNumber'] = undefined;

/**
 * @member {String} primaryContactNumberCountryCode
 */
PersonalDetails.prototype['primaryContactNumberCountryCode'] = undefined;

/**
 * @member {String} emailAddress
 */
PersonalDetails.prototype['emailAddress'] = undefined;

/**
 * @member {String} countryOfResidence
 */
PersonalDetails.prototype['countryOfResidence'] = undefined;

/**
 * @member {String} nationality
 */
PersonalDetails.prototype['nationality'] = undefined;

/**
 * @member {String} pictureFormat
 */
PersonalDetails.prototype['pictureFormat'] = undefined;

/**
 * @member {String} pictureBase64
 */
PersonalDetails.prototype['pictureBase64'] = undefined;

/**
 * @member {String} taxCode
 */
PersonalDetails.prototype['taxCode'] = undefined;
var _default = exports["default"] = PersonalDetails;